import {Component, ChangeDetectionStrategy, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SettingsService} from './services/settings.service';
import {PaletteService} from './services/palette.service';
import {ThemeService} from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet]
})
export class AppComponent {
  private settings = inject(SettingsService);
  private palette = inject(PaletteService);
  private theme = inject(ThemeService);

  constructor() {
    this.theme.init();
    // админ-превью палитр (localStorage) — до применения сайт-дефолтов
    this.palette.restorePreview();
    // настройки сайта: флаги разделов + палитры темы для всех посетителей
    // (в SSR запрос выполняется на сервере → атрибуты data-palette-*
    // попадают в отдаваемый HTML, без вспышки дефолтной палитры)
    this.settings.load().subscribe();
  }
}
